/**
 * AvatarAnimatorLazy — React.lazy wrapper for AvatarAnimator.
 *
 * This ensures PixiJS (~215 KB gzipped) is only loaded when the avatar
 * widget actually mounts, keeping the main dashboard bundle unchanged.
 */

import { lazy } from 'react';
import type { ComponentType } from 'react';
import type { AvatarAnimatorProps } from './AvatarAnimator';

const AvatarAnimatorLazy: ComponentType<AvatarAnimatorProps> = lazy(
  () => import('./AvatarAnimator'),
);

export default AvatarAnimatorLazy;